<template>
  <div>
    <div class="modal-main-header">
      <div>
        <h3 class="modal-header-changeType">{{ $t('changeUserType.changeUserType')}}</h3>
      </div>
        <svg
        class="header-close"
        @click="$bvModal.hide('change-user-type-massaction')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <div class="modal-main-content">
      <p class="modal-msg" v-html="$t('changeUserType.changeUserTypeConfirm')" />

      <vp-treeselect
        :options="userTypesOptions"
        v-model="userType"
        :label="$t('common.userType')"
        :placeholder="$t('common.userType')"
        :disabled="loading || submitting"
        :isLoading="loading"
        width="416"
        :isMultiple="false"
        :flat="false"
        :showPlaceholderIcon="true"
        dropDownStyle="absolute"
      />
    </div>
    <div class="line-divider"></div>
    <div class="d-flex justify-content-center">
      <button
        :disabled="$v.$invalid || submitting"
        @click="onsubmit"
        class="change-type"
      >
        {{ $t('common.change')}}
        <i
          v-if="submitting"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
      </button>
      <button
        :disabled="submitting"
        @click="$bvModal.hide('change-user-type-massaction')"
        class="cancel-type"
      >
        {{ $t('common.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import userService from "@/services/userType";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      userType: null,
      userTypesOptions: [],
      selectedUsersIds: [],
      loading: true,
      submitting: false,
    };
  },
  validations: {
    userType: {
      required,
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    async onsubmit() {
      this.submitting = true;
      //#TODO (1-Add api call) @param => this.selectedUsersIds
      const payload = this.selectedUsersIds.map((userId) => {
        return { user_id: userId, user_type_id: this.userType };
      });
      await userService.userTypeMassAction(payload);
      this.$bvModal.hide("change-user-type-massaction");
      this.$bvModal.show("change-user-type-massaction-success-message");
      this.submitting = false;
    },
  },
  async beforeMount() {
    this.selectedUsersIds = this.getModalInfo;

    const { data } = await userService.getPermittedUserTypes();
    this.userTypesOptions = data;

    this.loading = false;
  },
};
</script>

<style lang="scss">
div#change-user-type-massaction___BV_modal_content_ {
  width: 500px !important;
  border-radius: 26px !important;
  margin-top: 120px;
  .modal-main-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 40px;
    .modal-header-changeType {
      color: #000;
      font-size: 17px;
      font-weight: 700;
      line-height: normal;
      line-height: 100%;
      text-align: center;
    }

    .header-close{
      margin: -8px -10px; 
    }
  }

  .modal-main-header:lang(ar) {
    margin-right: 125px;
  }

  .modal-main-header:not(:lang(ar)){
    margin-left: 125px;
  }

  .modal-main-content {
    width: 416px;
    margin: auto;
    .modal-msg {
      margin-bottom: 32px;
      color: #787878;

      font-size: 16px;

      font-weight: 400;

    line-height: 24px;
    letter-spacing: 0%;

    }
  }

  .line-divider {
    height: 1px;
    background-color: #707070;
    opacity: 0.15;
    margin-top: 40px;
    margin-bottom: 24px;
  }

  button.cancel-type {
    width: 112px;
    height: 32px;
    color: #f46a6a;
    margin-inline-start: 16px;
    background-color: transparent;
    border-radius: 26px;
    border: solid 1px #f46a6a;
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: normal;
  }

  button.change-type {
    width: 112px;
    height: 32px;
    color: #ffffff;
    margin-inline-end: 16px;
    background-color: #103f5e;
    border-radius: 26px;
    border: solid 1px #103f5e;
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: normal;
    &:disabled {
      background-color: #9FB2BF !important;
      border: solid 1px #9FB2BF;
      
    }
  }
}
</style>
